export enum UploadStatus {
  // bridge 返回状态
  /** 压缩中 */
  Compressing = 1,
  /** 压缩成功 */
  CompressSucceed,
  /** 压缩失败 */
  CompressFailed,
  /** 上传中 */
  Uploading,
  /** 上传成功 */
  UploadSucceed,
  /** 上传失败 */
  UploadFailed,
  /** 取消上传 */
  UploadCanceled,

  // 下面是 自定义状态
  /** 获取token失败 */
  GetTokenFailed = 100,
  /** 发送消息中 */
  SendingMessage,
  /** 发送消息成功 */
  SendMessageSucceed,
  /** 发送消息失败 */
  SendMessageFailed,
  /** 会话已经结束 */
  SessionEnd
}

// 自定义的上传状态
export const CustomUploadStatus = [
  UploadStatus.GetTokenFailed,
  UploadStatus.SendMessageSucceed,
  UploadStatus.SendMessageFailed,
  UploadStatus.SessionEnd,
];

// 所有失败上传 且需要提示的状态
export const FailedStatusNeedPrompt = [
  UploadStatus.CompressFailed,
  UploadStatus.UploadFailed,
  UploadStatus.GetTokenFailed,
  UploadStatus.SendMessageFailed,
];

// 视频上传失败原因
export const VideoFailedReason = {
  [UploadStatus.GetTokenFailed]: 1,
  [UploadStatus.CompressFailed]: 2,
  [UploadStatus.UploadFailed]: 3,
  [UploadStatus.SendMessageFailed]: 4,
  [UploadStatus.SessionEnd]: 5,
};

export interface MediaBroadcast {
  /** bridge 给的 id */
  id: string;
  /** bridge 给的 id */
  vid: string;
  /** 当前的状态 */
  status: UploadStatus;
  /** 当前的进度，只有 0 和 100 */
  progress?: number;
  /** 图片 url，上传成功之后才有 */
  imageUrl?: string;
  /** 视频封面 url，上传成功之后才有 */
  videoCoverUrl?: string;
  /** 视频本地路径，压缩成功后才有 */
  videoFilePath?: string;
  /** 视频 url，上传成功之后才有 */
  videoUrl?: string;
  /** 视频上传耗时 ms */
  uploadCostTime?: number;
}

export interface MediasBroadcast {
  [id: string]: MediaBroadcast;
}

export enum VideoShowStatus {
  /** 展示 loading 图标 */
  Uploading,
  /** 展示播放图标 */
  Play,
  /** 展示失败图标 */
  Failed,
}

export interface MediasIdMapPosition {
  [id: string]: number;
}
